var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlignRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 4.5C3.5 3.94772 3.94772 3.5 4.5 3.5H20.5C21.0523 3.5 21.5 3.94772 21.5 4.5C21.5 5.05228 21.0523 5.5 20.5 5.5H4.5C3.94772 5.5 3.5 5.05228 3.5 4.5ZM7.5 19.5C7.5 18.9477 7.94772 18.5 8.5 18.5H20.5C21.0523 18.5 21.5 18.9477 21.5 19.5C21.5 20.0523 21.0523 20.5 20.5 20.5H8.5C7.94772 20.5 7.5 20.0523 7.5 19.5ZM3.5 14.5C3.5 13.9477 3.94772 13.5 4.5 13.5H20.5C21.0523 13.5 21.5 13.9477 21.5 14.5C21.5 15.0523 21.0523 15.5 20.5 15.5H4.5C3.94772 15.5 3.5 15.0523 3.5 14.5ZM7.5 9.5C7.5 8.94772 7.94772 8.5 8.5 8.5H20.5C21.0523 8.5 21.5 8.94772 21.5 9.5C21.5 10.0523 21.0523 10.5 20.5 10.5H8.5C7.94772 10.5 7.5 10.0523 7.5 9.5Z",
    fill: "#52525B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignRight);
export default __webpack_public_path__ + "static/media/AlignRight.dbafcdebbe54703c3d7132c1c06715f1.svg";
export { ForwardRef as ReactComponent };